import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Inject,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-device-information',
  templateUrl: './device-information.component.html',
  styleUrls: ['./device-information.component.scss'],
})
export class DeviceInformationComponent implements OnInit, AfterViewInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  deviceInformationForm!: FormGroup;
  errorMessage: string = '';
  focusOnPreviousModal = false;
  @Input() formGroupName!: string;
  @Output() submitToParent = new EventEmitter();
  @ViewChild('deviceInformation') deviceInformationField:
    | ElementRef
    | undefined;

  get formInstance() {
    return this.deviceInformationForm?.controls;
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.deviceInformationForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = this.stepper - 1));
  }

  /**
   * @description get all child formgroup control here before submission data transform as per api needs
   * @returns void
   */
  submit(): void {
    if (this.deviceInformationForm.invalid) return;
    this.submitToParent.emit(); //submit parent form
  }
  ngAfterViewInit() {
    if (!this.focusOnPreviousModal) {
      this.focusOnPreviousModal = true;
      this.cdr.detectChanges();
      this.deviceInformationField?.nativeElement.focus();
    }
  }
}
